/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Support_MessageInputs */



/**
* | output |
* | --- |
* | "For billing assistance, contact us at" |
*
* @param {Billing_Support_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const billing_support_message = /** @type {((inputs?: Billing_Support_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Support_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pour toute question relative à la facturation, veuillez nous contacter à l'adresse suivante :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bei Fragen zur Abrechnung kontaktieren Sie uns bitte unter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per assistenza sulla fatturazione, contattaci a")
	if (locale === "ru") return /** @type {LocalizedString} */ ("По вопросам выставления счетов обращайтесь к нам по адресу:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Para obtener ayuda con la facturación, contáctenos en")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("如需账单方面的帮助，请联系我们。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("請求に関するサポートについては、")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बिल संबंधी सहायता के लिए, हमसे संपर्क करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Para obter assistência com a faturação, entre em contacto connosco através do seguinte endereço:")
	return /** @type {LocalizedString} */ ("For billing assistance, contact us at")
});